import React from "react";
import { arrayOf, string } from "prop-types";

import "./shoulder-tags.m.css";

const EXCLUDED_TAGS = ["forum", "thematic", "open to all", "forum-exclusive"];

const ShoulderTags = ({ tags = ["Forum", "Thematic"], ...props }) => {
  const filteredTags = (tags || []).filter(
    (tag) => !EXCLUDED_TAGS.includes(tag.toLowerCase().trim())
  );

  if (filteredTags.length === 0) {
    return null;
  }

  return (
    <div styleName="shoulder-tags" {...props}>
      {filteredTags.map((tag, index) => (
        <div key={index} styleName="shoulder-tag">
          {tag}
        </div>
      ))}
    </div>
  );
};

ShoulderTags.propTypes = {
  tags: arrayOf(string)
};

export default ShoulderTags;